module.exports = __webpack_public_path__ + "img/intercontinental-network.c76d7818.jpg";